import ButtonDropdown from '@pelckmans/elementis/components/button-dropdown';
import MaterialSiteIcon from '@pelckmans/elementis/icons/material-site';
import { useTranslation } from 'react-i18next';
import ModalContext from '../../../../../../contexts/ModalContext';
import { useContext } from 'react';
import { Module } from '../../../../../../api/module';
import usePlatformName from '../../../../../../hooks/usePlatformName';
import AddBookwidgetMaterialModal from '../../../../../../shared-components/elementis/components/add-material-modal/add-bookwidget-material-modal';
import { TOKEN_ACCESSOR } from '../../../../../../utils/tokenAccessor';
import { Node } from '../../../../../../api/table-of-content';
import { useWithLicenseCheck } from '../useWithLicenseCheck';
import { buildAddBookwidgetUrl } from '../../../../../../shared-components/elementis/util/buildBookWidgetsUrl';

const BASE = 'PAGES.TOC_LEVEL.SECTIONS.TEACHER.MATERIAL';
const MODAL_ID = 'add-bookwidget-modal';

interface Props {
  selectedModule: Module;
  selectedNode: Node;
  onSubmit: () => void;
  onClick?: () => void; // Needed for Floating UI to handle onClicks correctly.
}

export default function AddBookwidgetDropdownItem({
  selectedModule,
  selectedNode,
  onSubmit: onSubmitCallback,
  onClick: onClickCallback,
}: Props) {
  const { t } = useTranslation();
  const { showModal } = useContext(ModalContext);
  const platformName = usePlatformName();
  const { licenseCheck } = useWithLicenseCheck();

  const onClick = licenseCheck(() => {
    showModal(
      <AddBookwidgetMaterialModal
        id={MODAL_ID}
        tokenAccessor={TOKEN_ACCESSOR}
        moduleId={selectedModule.id}
        nodeId={selectedNode.id}
        studioGroup={process.env.REACT_APP_P_STUDIO_GROUP}
        onSubmit={onSubmitCallback}
        bookwidgetUrl={buildAddBookwidgetUrl({
          ltipsUrl: process.env.REACT_APP_LTI_AUTH_URL,
          module: selectedModule,
          platformName,
          studioLanguage: process.env.REACT_APP_P_STUDIO_GROUP,
        })}
      />,
    );

    return onClickCallback?.();
  });

  return (
    <ButtonDropdown.Item
      onClick={onClick}
      text={t(`${BASE}.ADD_USER_MATERIAL_DROPDOWN_BUTTON.ITEMS.ADD_NEW_BOOKWIDGET`)}
      textIcon={<MaterialSiteIcon />}
    />
  );
}
